(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3081],{

/***/ 93284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/is-element/is-element.js
var is_element = __webpack_require__(24241);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Breadcrumbs/Breadcrumbs.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  root: {
    display: "flex",
    alignItems: "center"
  },
  breadcrumb: {
    lineHeight: 1,
    whiteSpace: "nowrap",
    WebkitTapHighlightColor: "transparent"
  },
  separator: {
    marginLeft: theme.spacing.xs,
    marginRight: theme.spacing.xs,
    color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

/* harmony default export */ var Breadcrumbs_styles = (useStyles);
//# sourceMappingURL=Breadcrumbs.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(64523);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Breadcrumbs/Breadcrumbs.js







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  separator: "/"
};
const Breadcrumbs = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Breadcrumbs", defaultProps, props), { className, children, separator, classNames, styles, unstyled } = _a, others = __objRest(_a, ["className", "children", "separator", "classNames", "styles", "unstyled"]);
  const { classes, cx } = Breadcrumbs_styles(null, { classNames, styles, unstyled, name: "Breadcrumbs" });
  const items = react.Children.toArray(children).reduce((acc, child, index, array) => {
    var _a2;
    const item = (0,is_element/* isElement */.k)(child) ? react.cloneElement(child, {
      className: cx(classes.breadcrumb, (_a2 = child.props) == null ? void 0 : _a2.className),
      key: index
    }) : /* @__PURE__ */ react.createElement("div", {
      className: classes.breadcrumb,
      key: index
    }, child);
    acc.push(item);
    if (index !== array.length - 1) {
      acc.push(/* @__PURE__ */ react.createElement(Text/* Text */.x, {
        size: "sm",
        className: classes.separator,
        key: `separator-${index}`
      }, separator));
    }
    return acc;
  }, []);
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.root, className),
    ref
  }, others), items);
});
Breadcrumbs.displayName = "@mantine/core/Breadcrumbs";


//# sourceMappingURL=Breadcrumbs.js.map


/***/ }),

/***/ 30853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createReactComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/defaultAttributes.js
/**
 * @tabler/icons-react v2.47.0 - MIT
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/createReactComponent.js
/**
 * @tabler/icons-react v2.47.0 - MIT
 */





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var createReactComponent = (iconName, iconNamePascal, iconNode) => {
  const Component = (0,react.forwardRef)(
    (_a, ref) => {
      var _b = _a, { color = "currentColor", size = 24, stroke = 2, children } = _b, rest = __objRest(_b, ["color", "size", "stroke", "children"]);
      return (0,react.createElement)(
        "svg",
        __spreadValues(__spreadProps(__spreadValues({
          ref
        }, defaultAttributes), {
          width: size,
          height: size,
          stroke: color,
          strokeWidth: stroke,
          className: `tabler-icon tabler-icon-${iconName}`
        }), rest),
        [...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)), ...children || []]
      );
    }
  );
  Component.propTypes = {
    color: (prop_types_default()).string,
    size: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
    stroke: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])
  };
  Component.displayName = `${iconNamePascal}`;
  return Component;
};


//# sourceMappingURL=createReactComponent.js.map


/***/ }),

/***/ 12162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconArrowRight; }
/* harmony export */ });
/* harmony import */ var _createReactComponent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30853);
/**
 * @tabler/icons-react v2.47.0 - MIT
 */



var IconArrowRight = (0,_createReactComponent_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("arrow-right", "IconArrowRight", [
  ["path", { d: "M5 12l14 0", key: "svg-0" }],
  ["path", { d: "M13 18l6 -6", key: "svg-1" }],
  ["path", { d: "M13 6l6 6", key: "svg-2" }]
]);


//# sourceMappingURL=IconArrowRight.js.map


/***/ }),

/***/ 61591:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tin-tuc",
      function () {
        return __webpack_require__(18053);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AB": function() { return /* binding */ useFetchNewsArticles; },
/* harmony export */   "G9": function() { return /* binding */ useFetchNewsArticle; },
/* harmony export */   "aC": function() { return /* binding */ useFetchNewsArticlesCount; },
/* harmony export */   "cW": function() { return /* binding */ DEFAULT_FETCHING_NEWS_OPTIONS; }
/* harmony export */ });
/* unused harmony exports fetchNewsArticle, fetchNewsArticles, fetchNewsArticlesCount */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67848);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85945);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36203);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40470);







var DEFAULT_STALE_TIME = 1000 * 60 * 30; // 30 min
var DEFAULT_FETCHING_NEWS_OPTIONS = {
    limit: 8,
    page: 1,
    condition: {
        ngon_ngu: "vi",
        loai_tin_tuc: [
            "Tin tức",
            "Tin tức Việt Thi\xean",
            "Tin tức c\xe0 ph\xea"
        ]
    }
};
var fetchNewsArticle = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetItem */ .p9)({
                        collection_name: "news",
                        options: {
                            shared: true,
                            condition: {
                                slug: slug
                            }
                        }
                    });
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticle(slug) {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticle = function(slug) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.detail */ .w3.detail(slug), function() {
        return fetchNewsArticle(slug);
    }, {
        // staleTime: DEFAULT_STALE_TIME,
        enabled: !!slug
    });
};
/* -------------------------------------------------------------------------- */ var fetchNewsArticles = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, _args = arguments;
        return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "news",
                        options: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            page: 1,
                            limit: 8,
                            sort: {
                                stt: 1,
                                date_created: -1
                            }
                        }, options), {
                            condition: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                                isnews: true,
                                ngon_ngu: "vi",
                                shared: true
                            }, (options === null || options === void 0 ? void 0 : options.condition) || {})
                        })
                    });
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticles() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticles = function(options) {
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_7__/* .useQueryClient */ .NL)();
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.list */ .w3.list(options), function() {
        return fetchNewsArticles(options);
    }, {
        enabled: !!options,
        staleTime: DEFAULT_STALE_TIME,
        onSuccess: function(newsArticles) {
            newsArticles.map(function(newsArticle) {
                queryClient.setQueriesData(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.detail */ .w3.detail(newsArticle === null || newsArticle === void 0 ? void 0 : newsArticle.slug), newsArticle);
            });
        }
    });
};
/* -------------------------------------------------------------------------- */ var fetchNewsArticlesCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, data, _args = arguments;
        return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return (0,_fetch__WEBPACK_IMPORTED_MODULE_1__/* .asyncGetList */ .NE)({
                        collection_name: "news",
                        options: {
                            count: true,
                            condition: {
                                ngon_ngu: "vi",
                                isnews: true
                            }
                        }
                    });
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", (data === null || data === void 0 ? void 0 : data.rows_number) || 0);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewsArticlesCount() {
        return _ref.apply(this, arguments);
    };
}();
var useFetchNewsArticlesCount = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(_queryKeys__WEBPACK_IMPORTED_MODULE_2__/* .newsKeys.count */ .w3.count((options === null || options === void 0 ? void 0 : options.condition) || {}), function() {
        return fetchNewsArticlesCount(options);
    }, {
        enabled: !!options,
        staleTime: DEFAULT_STALE_TIME
    });
};


/***/ }),

/***/ 48285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _setup_locale_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59963);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38623);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93284);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95117);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);





function AppBreadcrumbs(param) {
    var items = param.items, isLoading = param.isLoading;
    var getLabel = (0,_setup_locale_provider__WEBPACK_IMPORTED_MODULE_1__/* .useLocalContext */ .u)().getLabel;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
        visible: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Breadcrumbs */ .O, {
            children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: item.href || "#",
                    scroll: false,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                            color: "dark",
                            size: "sm",
                            lineClamp: index === items.length - 1 ? 1 : 2,
                            sx: {
                                width: index === items.length - 1 ? "fit-content" : "max-content"
                            },
                            children: getLabel(item.title)
                        })
                    })
                }, index);
            })
        })
    });
}
AppBreadcrumbs.propTypes = {
    items: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().array.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (AppBreadcrumbs);


/***/ }),

/***/ 51623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22312);
/* harmony import */ var _utils_lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59926);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);







function DefaultSEO(param) {
    var seo = param.seo;
    // console.log(445555, seo)
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    if (!seo || (0,_utils_lodash__WEBPACK_IMPORTED_MODULE_5__/* .isEmpty */ .xb)(seo)) return null;
    var images = [];
    if (seo.picture1) {
        images.push({
            url: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                src: seo.picture1,
                size: "xl"
            }),
            width: 1200,
            height: 630,
            alt: "Vi\xeạt Thi\xean",
            type: "image/*"
        });
    } else if (seo.picture2) {
        images.push({
            url: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                src: seo.picture2,
                size: "xl"
            }),
            width: 1200,
            height: 1200,
            alt: "Vi\xeạt Thi\xean",
            type: "image/*"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
        title: seo === null || seo === void 0 ? void 0 : seo.title,
        description: seo === null || seo === void 0 ? void 0 : seo.description,
        openGraph: {
            url: "https://vietthien.com",
            title: seo.title,
            description: seo.description,
            images: images,
            locale: locale,
            type: seo.type || "website",
            siteName: "Việt Thi\xean",
            article: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (seo === null || seo === void 0 ? void 0 : seo.article) || {})
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (DefaultSEO);


/***/ }),

/***/ 18053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ NewsPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./apis/queryFunctions/news.js
var queryFunctions_news = __webpack_require__(11775);
// EXTERNAL MODULE: ./common/Layout/Container/Container.js
var Container = __webpack_require__(6559);
// EXTERNAL MODULE: ./utils/appendImageUrlFromAPI.js
var appendImageUrlFromAPI = __webpack_require__(22312);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(38623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(62679);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(54777);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/createReactComponent.js + 1 modules
var createReactComponent = __webpack_require__(30853);
;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconCalendar.js
/**
 * @tabler/icons-react v2.47.0 - MIT
 */



var IconCalendar = (0,createReactComponent/* default */.Z)("calendar", "IconCalendar", [
  [
    "path",
    {
      d: "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M16 3v4", key: "svg-1" }],
  ["path", { d: "M8 3v4", key: "svg-2" }],
  ["path", { d: "M4 11h16", key: "svg-3" }],
  ["path", { d: "M11 15h1", key: "svg-4" }],
  ["path", { d: "M12 15v3", key: "svg-5" }]
]);


//# sourceMappingURL=IconCalendar.js.map

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 114 modules
var motion = __webpack_require__(2020);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./common/NewCardNew/index.js










var useStyles = (0,create_styles/* createStyles */.k)(function() {
    return {
        imageWrapper: {
            width: "100%",
            height: "75px",
            aspectRatio: "1/0.5",
            position: "relative"
        }
    };
});
function NewCardNew(param) {
    var item = param.item, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var classes = useStyles().classes;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        whileHover: {
            scale: 1.02
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            shadow: "sm" /*  bg="pink" */ ,
            p: 0,
            radius: "md",
            sx: {
                height: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                scroll: false,
                href: "/tin-tuc/".concat(item === null || item === void 0 ? void 0 : item.slug) || 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        visible: isLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                            align: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                    span: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classes.imageWrapper,
                                        children: !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,appendImageUrlFromAPI/* default */.Z)({
                                                src: item === null || item === void 0 ? void 0 : item.picture,
                                                size: "s"
                                            }),
                                            alt: "Norway",
                                            layout: "fill",
                                            objectFit: "contain"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                    span: 8,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                                order: 1,
                                                style: {
                                                    letterSpacing: 1
                                                },
                                                transform: "capitalize",
                                                size: "xs",
                                                lineClamp: 2,
                                                weight: "600",
                                                children: (item === null || item === void 0 ? void 0 : item.title) || "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                                                size: "xs" /* my="sm" */ ,
                                                style: {
                                                    background: "black"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCalendar, {
                                                        size: 15
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                        size: "xs",
                                                        ml: 8,
                                                        children: new Date(item === null || item === void 0 ? void 0 : item.date_updated).toLocaleDateString(locale, {
                                                            year: "numeric",
                                                            month: "2-digit",
                                                            day: "2-digit"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}
/* harmony default export */ var common_NewCardNew = (NewCardNew);

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Card/Card.js + 4 modules
var Card = __webpack_require__(21017);
;// CONCATENATED MODULE: ./common/NewCardProSub/styles.js

var styles_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        imageWrapper: {
            aspectRatio: "1.65",
            position: "relative"
        },
        customCard: {
            width: "100%",
            height: "250px",
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "white",
            textAlign: "start",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "center"
        },
        cardContent: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            padding: "10px",
            borderRadius: "0 0 10px 10px",
            width: "100%",
            boxSizing: "border-box"
        }
    };
});
/* harmony default export */ var styles = (styles_useStyles);

;// CONCATENATED MODULE: ./common/NewCardProSub/index.js











function NewCardProSub(param) {
    var item = param.item, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var classes = styles().classes;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        whileHover: {
            scale: 1.02
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            shadow: "sm" /*  bg="pink" */ ,
            p: 0,
            radius: "md",
            sx: {
                height: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                scroll: false,
                href: "/tin-tuc/".concat(item === null || item === void 0 ? void 0 : item.slug) || 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                        visible: isLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                            className: classes.customCard,
                            padding: "md",
                            style: {
                                backgroundImage: "url(".concat((0,appendImageUrlFromAPI/* default */.Z)({
                                    src: item === null || item === void 0 ? void 0 : item.picture,
                                    size: "m"
                                }), ")")
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.cardContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                        order: 1,
                                        size: "sm",
                                        lineClamp: 2,
                                        children: item === null || item === void 0 ? void 0 : item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        size: "sm",
                                        children: new Date(item === null || item === void 0 ? void 0 : item.date_updated).toLocaleDateString(locale, {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}
/* harmony default export */ var common_NewCardProSub = (NewCardProSub);

// EXTERNAL MODULE: ./common/components/Breadcrumbs.js
var Breadcrumbs = __webpack_require__(48285);
// EXTERNAL MODULE: ./common/components/DefaultSEO.js
var DefaultSEO = __webpack_require__(51623);
// EXTERNAL MODULE: ./node_modules/@mantine/carousel/esm/Carousel.js + 6 modules
var Carousel = __webpack_require__(41720);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 2 modules
var Group = __webpack_require__(66137);
;// CONCATENATED MODULE: ./common/NewCardPro/index.js










var NewCardPro_useStyles = (0,create_styles/* createStyles */.k)(function() {
    return {
        imageWrapper: {
            /* width: "100%",
    height:"100%", */ aspectRatio: "2.25",
            position: "relative"
        }
    };
});
function NewCardPro(param) {
    var item = param.item, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var classes = NewCardPro_useStyles().classes;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        whileHover: {
            scale: 1.01
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
            shadow: "sm",
            p: 0,
            radius: "md",
            sx: {
                height: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                scroll: false,
                href: "/tin-tuc/".concat(item === null || item === void 0 ? void 0 : item.slug) || 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                            visible: isLoading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.imageWrapper,
                                    children: !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: (0,appendImageUrlFromAPI/* default */.Z)({
                                            src: item === null || item === void 0 ? void 0 : item.picture,
                                            size: "m"
                                        }),
                                        alt: "Norway",
                                        layout: "fill",
                                        objectFit: "fill"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            p: "md",
                            bg: "#F8F8F8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton/* Skeleton */.O, {
                                    visible: isLoading,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                            order: 1,
                                            style: {
                                                letterSpacing: 1
                                            },
                                            transform: "capitalize",
                                            size: "sm",
                                            lineClamp: 2,
                                            weight: "600",
                                            children: (item === null || item === void 0 ? void 0 : item.title) || "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                                            size: "xs",
                                            my: "sm",
                                            style: {
                                                background: "black"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                    visible: isLoading,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        size: "sm",
                                        children: new Date(item === null || item === void 0 ? void 0 : item.date_updated).toLocaleDateString(locale, {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var common_NewCardPro = (NewCardPro);

;// CONCATENATED MODULE: ./common/components/SlideNews.js
/* eslint-disable react/no-array-index-key */ /* eslint-disable no-underscore-dangle */ 





function SlideNews(param) {
    var news = param.news;
    //   console.log(22222, news)
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            size: "xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
                        dragFree: true,
                        controlSize: 50,
                        // slideSize="50%"s
                        // w={330}
                        w: "100%",
                        slideGap: "xs",
                        bg: "#F8F8F8",
                        initialSlide: 1,
                        mx: "auto",
                        children: news ? news.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                xs: 12,
                                sm: 6,
                                lg: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NewCardPro, {
                                    item: item
                                })
                            }, item._id);
                        }) : Array(4).fill(undefined).map(function(item, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                xs: 12,
                                sm: 6,
                                lg: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NewCardPro, {
                                    item: item,
                                    isLoading: true
                                })
                            }, i);
                        })
                    })
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./hooks/useTrans.js + 2 modules
var useTrans = __webpack_require__(26679);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Flex/Flex.js + 1 modules
var Flex = __webpack_require__(69876);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(64523);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconArrowRight.js
var IconArrowRight = __webpack_require__(12162);
;// CONCATENATED MODULE: ./pages/tin-tuc/index.page.js

















var __N_SSG = true;
function NewsPage() {
    var locale = (0,router.useRouter)().locale;
    var trans = (0,useTrans/* default */.Z)();
    var ref = (0,queryFunctions_news/* useFetchNewsArticles */.AB)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryFunctions_news/* DEFAULT_FETCHING_NEWS_OPTIONS */.cW), {
        condition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryFunctions_news/* DEFAULT_FETCHING_NEWS_OPTIONS.condition */.cW.condition), {
            ngon_ngu: locale,
            thong_tin_km: true
        })
    })), hlnews = ref.data;
    var breadcrumbs = [
        {
            title: locale === "vi" ? "Trang chủ" : "Home",
            href: "/"
        },
        {
            title: locale === "vi" ? "Tin tức Việt Thi\xean" : "Viet Thien News",
            href: "/tin-tuc"
        }, 
    ];
    var ref1 = (0,react.useState)(1), page = ref1[0], setPage = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState({
        limit: 2000,
        page: 1,
        condition: {
            ngon_ngu: locale
        }
    }), 2), options = ref2[0], setOptions = ref2[1];
    console.log("update_84");
    var ref3 = (0,queryFunctions_news/* useFetchNewsArticles */.AB)(options), news = ref3.data;
    (0,react.useEffect)(function() {
        setOptions(function(prevOps) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevOps), {
                page: page,
                condition: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevOps === null || prevOps === void 0 ? void 0 : prevOps.condition), {
                    ngon_ngu: locale
                })
            });
        });
    }, [
        page,
        locale
    ]);
    var seo = {
        title: [
            "Tin tức Việt Thi\xean"
        ]
    };
    var renderNews = function(title, type, link) {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    scroll: false,
                    href: "/tin-tuc/".concat(link),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            align: "center",
                            c: "#000",
                            bg: "#fff",
                            order: 1,
                            size: "h4",
                            mb: 20,
                            children: title
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        paddingBottom: "15px"
                    },
                    children: news ? news.filter(function(item) {
                        return item.loai_tin_tuc === type;
                    }).slice(0, 1).map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NewCardProSub, {
                                item: item
                            })
                        }, item._id);
                    }) : Array(8).fill(undefined).map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NewCardNew, {
                                item: item,
                                isLoading: true
                            })
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                    mih: 50,
                    gap: 20,
                    justify: "flex-start",
                    align: "flex-start",
                    direction: "column",
                    children: news ? news.filter(function(item) {
                        return item.loai_tin_tuc === type;
                    }).slice(1, 5).map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NewCardNew, {
                                item: item
                            })
                        }, item._id);
                    }) : Array(8).fill(undefined).map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_NewCardNew, {
                                item: item,
                                isLoading: true
                            })
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    scroll: false,
                    href: "/tin-tuc/".concat(link),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "18px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            bg: "#fff",
                            s: true,
                            p: "10px 20px 10px 20px",
                            size: 16,
                            weight: 700,
                            display: "inline-flex",
                            sx: {
                                borderRadius: "10px"
                            },
                            children: [
                                trans === null || trans === void 0 ? void 0 : trans.homeAbout.seeMore,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowRight/* default */.Z, {
                                    size: 20,
                                    style: {
                                        margin: "3px 0 0 10px"
                                    }
                                })
                            ]
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultSEO/* default */.Z, {
                seo: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                size: "xl",
                mt: 20,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                        items: breadcrumbs,
                        isLoading: !breadcrumbs
                    }),
                    (hlnews === null || hlnews === void 0 ? void 0 : hlnews.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        mt: 20,
                        pt: 10,
                        pb: 30,
                        bg: "#F8F8F8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                align: "center",
                                bg: "#fff",
                                c: "#000",
                                order: 1,
                                size: "h4",
                                mb: 20,
                                p: "xs",
                                children: locale === "vi" ? "Tin tức nổi bật" : "Hot news"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideNews, {
                                news: hlnews
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        py: 20,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            pt: "xl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                                justify: "space-between",
                                align: "flex-start",
                                gutter: 50,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                        xs: 12,
                                        sm: 6,
                                        lg: 4,
                                        children: renderNews(locale === "vi" ? "Tin tức tr\xe0" : "Tea news", "Tin tức", "tra")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                        xs: 12,
                                        sm: 6,
                                        lg: 4,
                                        children: renderNews(locale === "vi" ? "Tin tức cafe" : "Coffee news", "Tin tức c\xe0 ph\xea", "ca-phe")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                        xs: 12,
                                        sm: 6,
                                        lg: 4,
                                        children: renderNews(locale === "vi" ? "Tin tức n\xf4ng sản" : "Agriculture news", "Tin tức Việt Thi\xean", "nong-san")
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6595,296,8392,9774,2888,179], function() { return __webpack_exec__(61591); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);